<template>
  <base-dropdown>
    <template #trigger>
      <base-skeleton width="40%" height="14px" border-radius="100px" />
    </template>
    <template #content></template>
  </base-dropdown>
</template>

<script>
import BaseSkeleton from '@/shared/ui/BaseSkeleton/BaseSkeleton.vue'
import BaseDropdown from '@/shared/ui/BaseDropdown/BaseDropdown.vue'

export default {
  components: {
    BaseSkeleton,
    BaseDropdown,
  },
}
</script>
